import { WorkareaGroupWithWorkareas } from '../../../domain/workareas/group'
import { PricingTypes } from '../../../common/constants'
import { WorkareaSelectedPricing } from '../../../domain/workareas/workareaPricingApi'
import { NewInvoiceData } from './createInvoiceModel'

export const applySelectedInvoicePricing = (state: NewInvoiceData, pricing: WorkareaSelectedPricing[]): NewInvoiceData => ({
  ...state,
  workareaGroups: state.workareaGroups.map(group => {
    if (group.pricingType === PricingTypes.QuotedPrice || group.pricingType === PricingTypes.PerVisit) {
      return group
    }
    const selected = pricing.filter(x => group.workareaIds.includes(x.workareaId))
    return selected.length ? { ...group, amount: selected.reduce((total, x) => total + x.actual.customerTotal, 0) } : group
  }),
})

export const buildInvoicePricingSelections = (state: NewInvoiceData, groups: WorkareaGroupWithWorkareas[]) => {
  const eligibleIds = groups.filter(group => group.workareas.some(workarea => !!workarea.pricing)).map(group => group.id)
  const selectedGroups = state.workareaGroups.filter(group => group.selected && eligibleIds.includes(group.id)
    && group.pricingType !== PricingTypes.QuotedPrice && group.pricingType !== PricingTypes.PerVisit)
  return {
    recoveryGroupIds: selectedGroups.map(group => group.id),
    selections: selectedGroups.map(group => ({ workareaIds: group.workareaIds, actualItemIds: group.selectedItemGuids, uninvoicedOnly: true })),
  }
}
